<template>
  <div class="panel-body">
    <a class='btn btn-default' @click="$router.go(-1)"><i class='fa fa-arrow-left'></i>
      {{$t('words.back')}}</a>
    <br>
    <br>
    <div class="row">
      <div class="col-md-12">
        <filterable @loading="changeLoading" ref="filter" v-bind="filterable">
          <thead slot="thead">
            <tr>
              <th class="col-md-1">{{$t('words.options')}}</th>
              <th>{{$t('attributes.name')}}</th>
              <th>{{$t('attributes.description')}}</th>
              <th>{{$t('words.deleted_at')}}</th>
            </tr>
          </thead>
          <tr slot-scope="{item, dropup}">
            <td class="column-options">
              <div class="btn-group" :class="{'dropup': dropup}">
                <button type="button" class="btn btn-default btn-sm dropdown-toggle"
                  v-bind:title="$t('words.operations')" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fa fa-bars" aria-hidden="true"></i>
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">                  
                    <a class="dropdown-item" @click="detailsObject(item)">
                      <i class="fa fa-eye"></i>
                      {{$t('words.details') }}
                    </a>                  
                    <a class="dropdown-item" @click="recoveryData(item.id)">
                      <i class="fa fa-undo"></i> {{ $t('words.restore') }} </a>                  
                    <a class="dropdown-item" @click="deleteData(item.id, item.cargo_nome)">
                      <i class="fa fa-trash-o" aria-hidden="true"></i>{{ $t('words.delete') }} </a>
                </ul>
              </div>
            </td>
            <td>{{item.cargo_nome}}</td>
            <td>{{item.cargo_descricao}}</td>
            <td>{{item.deleted_at}}</td>
          </tr>
        </filterable>
      </div>
    </div>
    <show-data :description="description" :data="objectDetails" :headers="headers"></show-data>
  </div>
</template>

<script>
  /* eslint-disable no-undef */
  export default {
    data() {
      return {
        filterable: {
          storeAction: 'setCargosDeleted',
          storeName: 'cargo.deleted',
          model: 'cargo',
          url: '/api/cargos/excluidos',
          deleted: false
        },
        objectDetails: {},
        description: 'cargo_descricao',
        headers: {
          'Nome': 'cargo_nome',
          'Descrição': 'cargo_descricao',
          'Deletado em': 'deleted_at'
        }
      };
    },
    computed: {
      cargos() {
        return this.$store.state.cargo.deleted;
      }
    },
    watch: {
      $route(data) {
        if (data.name === 'cargoDeleted') {
          this.prepareComponent();
        }
      }
    }
  };
</script>